// ============================================
// VENTE SECTION - Extrait de PropertyForm.jsx
// Étape 1.6: Intégration avec ctx
// Behavior: INCHANGÉ
// ============================================
import React from 'react';

/**
 * Section Vente/Informations financières du formulaire de bien
 * @param {Object} ctx - Contexte partagé
 */
const VenteSection = ({ ctx }) => {
  const {
    formData,
    handleNestedChange
  } = ctx;

  return (
    <div className="space-y-8">
      {/* Modern info header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-emerald-500/5 via-green-500/5 to-teal-500/10 border border-white/20 backdrop-blur-sm">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600/10 to-green-600/10"></div>
        <div className="relative p-6 flex items-center">
          <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-green-600 rounded-2xl flex items-center justify-center text-white mr-4 shadow-lg shadow-emerald-500/25">
            <i className="bi bi-currency-euro text-2xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-emerald-600 bg-clip-text text-transparent">
              Informations de Vente
            </h2>
            <p className="text-gray-600 font-medium">
              Conditions de vente et disponibilité
            </p>
          </div>
        </div>
      </div>

      {/* Informations de vente */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Prix annoncé (€)</label>
            <input
              type="number"
              value={formData.informations_vente?.prix_annonce || ''}
              onChange={(e) => handleNestedChange('informations_vente', 'prix_annonce', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Prix minimum accepté (€)</label>
            <input
              type="number"
              value={formData.informations_vente?.prix_minimum_accepte || ''}
              onChange={(e) => handleNestedChange('informations_vente', 'prix_minimum_accepte', parseFloat(e.target.value) || 0)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Date de disponibilité</label>
            <input
              type="date"
              value={formData.informations_vente?.date_disponibilite || ''}
              onChange={(e) => handleNestedChange('informations_vente', 'date_disponibilite', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Délai de libération</label>
            <input
              type="text"
              value={formData.informations_vente?.delai_liberation || ''}
              onChange={(e) => handleNestedChange('informations_vente', 'delai_liberation', e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-emerald-500"
              placeholder="Ex: 3 mois après signature"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenteSection;
